import React, { useState, useEffect } from "react";
import Select from "react-select";

const UserDropdown = ({ selectedUser, handleSelectUser }) => {
  const [options, setOptions] = useState([]);

  // Fetch users from backend
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/publications/summary`)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const formatted = data.map(([userId, username]) => ({
            value: userId,
            label: `${username} (${userId})`,
          }));
          setOptions(formatted);
        }
      })
      .catch((error) => console.error("Error fetching users:", error));
  }, []);

  return (
    <div>
      <Select
        options={options}
        value={selectedUser}
        onChange={handleSelectUser}
        placeholder="Select a user..."
        isClearable
      />
    </div>
  );
};

export default UserDropdown;
